<template>
  <div class="game-powerup-percentage">
    <span
      class="game-powerup-percentage__progress"
      :style="{ transform: `scaleX(${$store.state.powerUpPercentage})` }"
    />
  </div>
</template>

<script>
export default {
  name: 'GamePowerupPercentage',
};
</script>

<style lang="scss" scoped>
.game-powerup-percentage {
  position: relative;
  width: 55px;
  height: 10px;

  background-color: #F5E5E2;
  border: 2px solid #F5E5E2;

  border-radius: 15px;

  overflow: hidden;

  &__progress {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: $gold;
    transform-origin: left center;
    transition: transform 0.1s linear;
  }

  @extend %grain;

  @include mq(ipadP, $and: $is-not-touch-device) {
    width: 80px;
    height: 15px;

    border: 3px solid #F5E5E2;
  }
}
</style>
